export default function SessionExpired() {
  const params = new URLSearchParams(window.location.search);
  const reason = params.get("reason");

  let message = "Session expired. Please re-launch activity.";

  if (reason === "idle") {
    message = "Session expired due to inactivity. Please re-launch activity.";
  } else if (reason === "expired") {
    message = "Your session has expired. Please re-launch activity.";
  }

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h2>Session Expired</h2>
      <p>{message}</p>
    </div>
  );
}